import { Brand, Enterprise } from 'apis/enterprise/types';
import { Merchant } from 'apis/restaurant-api/merchant-admin/merchant/types';
import { VenueGroupItem } from 'apis/venue-groups/types';

export type VenueDataFromAPI = {
  venue_id: string;
  venue_name: Localized;
  is_open: boolean;
  is_online: boolean;
  is_merchant_app_alive: boolean;
  phone?: string;
  status: VenuePublishStatus;
  city_name: string;
  listimage: string;
  listimage_blurhash: string;
  merchant_name: Localized;
  venue_address: string;
  public_visible: boolean;
  created_at: number;
};

export type VenueRow = {
  id: string;
  name: Localized;
  address: string;
  status: VenueAvailabilityStatus;
  merchantName: Localized;
  contact?: string;
  listImage: string;
  cityName: string;
};

export enum VenuePublishStatus {
  VENUE_UNPUBLISHED = 'VENUE_UNPUBLISHED',
  VENUE_PUBLISHED = 'VENUE_PUBLISHED',
  VENUE_DELETED = 'VENUE_DELETED',
}

export enum VenueAvailabilityStatus {
  IPAD_NOT_ALIVE = 'ipadNotAlive',
  OFFLINE = 'offline',
  CLOSED = 'closed',
  AVAILABLE = 'available',
  INACTIVE = 'inactive',
}

export type Entity =
  | { type: 'merchant'; merchant: Merchant }
  | { type: 'brand'; brand: Brand }
  | { type: 'enterprise'; enterprise: Enterprise }
  | { type: 'venue-group'; venueGroup: VenueGroupItem };
